export default __webpack_public_path__ + "static/media/Takeaway_Inprogress.bb877163.svg";